module.exports = __webpack_public_path__ + "assets/img/404.a5d86fc2.png";